import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Calendar as CalendarIcon } from '@livingdesign/icons';

import styles from './styles.module.css';
import StatusCard from '../../../components/StatusCard/index.tsx';
import { ihutSelectors } from '../../../redux/slices/ihut.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { IhutActivity } from '../../../api/ihut.ts';
import moment from 'moment';
import config from '../../../config/config.js';
import { logger } from '../../../utils/logger.js';

const ProductFeedbackSurveyCard = () => {
  const { t } = useTranslation('ihut');
  const activity = useAppSelector(
    ihutSelectors.selectSelectedActivity
  ) as IhutActivity;

  if (activity.survey?.type !== 'FEEDBACK') return <></>;

  const { isFeedbackSurveyTaken } = activity;

  const handleClick = () => {
    if (isFeedbackSurveyTaken) return;
    const panelistId = localStorage.getItem('panelistId');
    const { ihutProjectId, surveyLink } = activity;
    if (!panelistId || !surveyLink) return;
    logger.info('Redirecting panelist to feedback survey', {
      ihutProjectId,
      panelistId,
      surveyLink
    });
    window.location.href = `${config.uiDomain}${activity.surveyLink}?panelist_hash=${panelistId}`;
  };

  return (
    <StatusCard
      status="product-feedback-survey"
      imgSrc={
        isFeedbackSurveyTaken
          ? '/assets/images/ihut/celebration-circle.png'
          : '/assets/images/ihut/feedback.png'
      }
      onClick={handleClick}
      showTag={isFeedbackSurveyTaken}
      tagProps={{
        text: t('shareFeedbackStep.card.successTag'),
        variant: 'tertiary',
        color: 'green'
      }}
    >
      <StatusCard.Caption>
        {t('selectedActivity.id', { activityId: activity.shortId })}
      </StatusCard.Caption>
      <StatusCard.Heading>
        {t('shareFeedbackStep.card.title')}
      </StatusCard.Heading>
      {!isFeedbackSurveyTaken && (
        <StatusCard.Caption extraClasses={styles.activityCompleteDateText}>
          <CalendarIcon className={styles.calendarIcon} />
          <Trans
            t={t}
            i18nKey="shippingInfo.completeBy"
            values={{
              date: moment(activity.survey.endTime).format('MM/DD/YYYY')
            }}
          >
            Complete by:
            <StatusCard.Caption
              weight={700}
              extraClasses={styles.activityCompleteDateText}
            >
              {' '}
              MM/DD/YYYY
            </StatusCard.Caption>
          </Trans>
        </StatusCard.Caption>
      )}
      <StatusCard.Text>
        {t('selectedActivity.points', {
          points: activity.survey?.completePoints || 0
        })}
      </StatusCard.Text>
    </StatusCard>
  );
};

export default ProductFeedbackSurveyCard;
